import mutations from './charge-activity-mutations';
import * as actions from './charge-activity-actions';

export default {
  namespaced: true,
  state: {
    charge_activity: null, // 充值赠送优惠券数据
  },
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/charge-activity/charge-activity-store.js